export default "__VITE_ASSET__RTbyGUX4__"